import { NotificationInboxItem } from "services/api/notifications/types";

export type InboxGroupKey = "today" | "yesterday" | "older";

export interface InboxGroup {
  key: InboxGroupKey;
  label: string;
  items: NotificationInboxItem[];
}

const GROUP_LABELS: Record<InboxGroupKey, string> = {
  today: "Danas",
  yesterday: "Jučer",
  older: "Starije",
};

/** Ponoć lokalnog dana — usporedba ide po danu, ne po proteklim satima. */
const startOfDay = (date: Date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate());

const resolveKey = (created: Date, now: Date): InboxGroupKey => {
  const daysApart = Math.round(
    (startOfDay(now).getTime() - startOfDay(created).getTime()) / 86_400_000
  );

  // Zapis s vremenom u budućnosti (razmak u satnim zonama) ide među današnje, ne među stare.
  if (daysApart <= 0) return "today";
  if (daysApart === 1) return "yesterday";

  return "older";
};

/**
 * Obavijesti razvrstane u Danas / Jučer / Starije.
 *
 * `now` se prima izvana da se ponašanje da testirati; prazne skupine se izostavljaju, a
 * redoslijed unutar skupine ostaje onakav kakav je stigao s backenda (najnovije prvo).
 */
export const groupInboxByDay = (
  items: NotificationInboxItem[],
  now: Date
): InboxGroup[] => {
  const buckets: Record<InboxGroupKey, NotificationInboxItem[]> = {
    today: [],
    yesterday: [],
    older: [],
  };

  for (const item of items) {
    buckets[resolveKey(new Date(item.created), now)].push(item);
  }

  return (["today", "yesterday", "older"] as InboxGroupKey[])
    .filter((key) => buckets[key].length > 0)
    .map((key) => ({ key, label: GROUP_LABELS[key], items: buckets[key] }));
};
